import { PollCursor } from '../../_utils/poll-cursor.util'

export interface SiteLogPollResponse {
  data: {
    logEntries: any
  }
  cursor?: PollCursor
  backfilling: boolean
  id: number
  done: boolean
}

export interface SiteLogPollErrorResponse {
  text: string
}

export enum SiteLogPollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
  Backfill = 5,
}

export enum SiteLogPollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
